<template>
  <div>
    <cbs-card-actions
      action-close
      title="Upload File"
      @close="onCancel"
    >
      <b-card-body>
        <b-form-file
          v-model="file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
        <!-- buttons -->
        <b-button-toolbar
          key-nav
          aria-label="Toolbar with button groups"
          class="demo-inline-spacing"
        >
          <b-button-group
            size="sm"
            class="cbs-inline-spacing"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="danger"
              @click="onCancel"
            >
              <feather-icon icon="XIcon" />
              Cancel
            </b-button>
          </b-button-group>
          <b-button-group
            size="sm"
            class="cbs-inline-spacing"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="warning"
              @click="clearFile"
            >
              <feather-icon icon="DeleteIcon" />
              Clear
            </b-button>
          </b-button-group>
          <b-button-group
            size="sm"
            class="cbs-inline-spacing"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="success"
              :disabled="!file"
              @click="onUpload"
            >
              <feather-icon icon="UploadIcon" />
              Upload
            </b-button>
          </b-button-group>
          <b-button-group
            v-if="isAdmin()"
            size="sm"
            class="cbs-inline-spacing"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              :variant="isDebug ? 'primary' : 'outline-primary'"
              @click="isDebug = !isDebug"
            >
              <feather-icon icon="CodeIcon" /> Debug
            </b-button>
          </b-button-group>
        </b-button-toolbar>
        <!-- /buttons -->

        <!-- debug -->
        <b-row v-if="isDebug">
          <b-col>
            <div style="margin-top:10px;">
              <div style="margin:10px">
                Props: <json-viewer
                  :value="getProps()"
                  :expand-depth="0"
                  sort
                />
                Data: <json-viewer
                  :value="getData()"
                  :expand-depth="0"
                  sort
                />
                Session: <json-viewer
                  :value="session()"
                  :expand-depth="0"
                  sort
                />
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- /debug -->
      </b-card-body>
    </cbs-card-actions>
  </div>
</template>

<script>
import useCubus from '@/cubus/services/useCubus'
import {
  BButton, BButtonGroup, BButtonToolbar, BCardBody, BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import CbsCardActions from '@/cubus/components/cbs-card-actions/CbsCardActions.vue'
import useJwt from '@/cubus/jwt/useJwt'

export default {
  name: 'CbsFileUpload',
  components: {
    BFormFile,
    BButtonToolbar,
    BButtonGroup,
    BButton,
    CbsCardActions,
    BCardBody,
  },
  emits: [
    'save',
  ],
  directives: {
    Ripple,
  },
  data() {
    return {
      file: null,
      isDebug: false,
      record: null,
    }
  },
  methods: {
    onCancel() {},
    clearFile() {
      this.file = null
    },
    async onUpload() {
      try {
        const s3Result = await useCubus.uploadFileToS3(this.file)
        const response = await useJwt.query({
          query: {
            method: 'uploadfiles3',
            mode: 'sync',
            param: {
              s3key: s3Result.key,
              s3bucket: s3Result.bucket,
              filename: s3Result.filename,
              contentType: s3Result.contentType,
              filesize: s3Result.filesize,
            },
          },
        })
        if (response.data.error) {
          useCubus.toastError(this, response.data.error)
        } else if (response.data.result && response.data.result.record) {
          this.onSave(response.data.result.record)
        }
      } catch (error) {
        console.log('upload error', error)
        useCubus.toastError(this, error)
      }
    },
    isAdmin() {
      return useCubus.isAdmin()
    },
    onSave(rec) {
      this.$emit('save', rec)
    },
  },
}
</script>

<style scoped>

</style>
